import React from "react";
import { Link } from "react-router-dom";
import i18n from "../../utils/lang/i18n";
import { Trans } from 'react-i18next';
import { useTranslation } from 'react-i18next';
import classnames from "classnames";
import { setCookie, getCookie } from 'react-use-cookie';
// reactstrap components
import {
  Button,
  Collapse,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
  UncontrolledTooltip,
} from "reactstrap";

export default function IndexNavbar() {
  const [collapseOpen, setCollapseOpen] = React.useState(false);
  const [collapseOut, setCollapseOut] = React.useState("");
  const [color, setColor] = React.useState("navbar-transparent");
  const [currentLanguage, setCurrentLanguage] = React.useState('pt_br');
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { t } = useTranslation();


  const handleClose = (value:any) => {
    i18n.changeLanguage(value).then(() => {
      setCurrentLanguage(value);
      setCookie('i18n_locale', value);
    });
    setAnchorEl(null);
  };

  React.useEffect(() => {
    window.addEventListener("scroll", changeColor);
    return function cleanup() {
      window.removeEventListener("scroll", changeColor);
    };
  }, []);
  const changeColor = () => {
    if (
      document.documentElement.scrollTop > 99 ||
      document.body.scrollTop > 99
    ) {
      setColor("bg-info");
    } else if (
      document.documentElement.scrollTop < 100 ||
      document.body.scrollTop < 100
    ) {
      setColor("navbar-transparent");
    }
  };
  const toggleCollapse = () => {
    document.documentElement.classList.toggle("nav-open");
    setCollapseOpen(!collapseOpen);
  };
  const onCollapseExiting = () => {
    setCollapseOut("collapsing-out");
  };
  const onCollapseExited = () => {
    setCollapseOut("");
  };
  return (
    <Navbar className={"fixed-top " + color} color-on-scroll="100" expand="lg">
      <Container>
        <div className="navbar-translate">
          <NavbarBrand to="/" tag={Link} id="navbar-brand">
          <img
                alt="Connected Church Logo"
                className="logo"
                src={require("assets/img/conectados_clara.webp")}
            />
          </NavbarBrand>
          <UncontrolledTooltip placement="bottom" target="navbar-brand">
          <Trans>Church Connected</Trans>
          </UncontrolledTooltip>
          <button
            aria-expanded={collapseOpen}
            className="navbar-toggler navbar-toggler"
            onClick={toggleCollapse}
          >
            <span className="navbar-toggler-bar bar1" />
            <span className="navbar-toggler-bar bar2" />
            <span className="navbar-toggler-bar bar3" />
          </button>
        </div>
        <Collapse
          className={"justify-content-end " + collapseOut}
          navbar
          isOpen={collapseOpen}
          onExiting={onCollapseExiting}
          onExited={onCollapseExited}
        >
          <div className="navbar-collapse-header">
            <Row>
              <Col className="collapse-brand" xs="6">
                <a href="#pablo" onClick={(e) => e.preventDefault()}>
                  Connected•
                </a>
              </Col>
              <Col className="collapse-close text-right" xs="6">
                <button
                  aria-expanded={collapseOpen}
                  className="navbar-toggler"
                  onClick={toggleCollapse}
                >
                  <i className="tim-icons icon-simple-remove" />
                </button>
              </Col>
            </Row>
          </div>
          <Nav navbar>
            <NavItem className="p-0">
              <NavLink
                data-placement="bottom"
                href="https://www.instagram.com/igreja.conectados"
                rel="noopener noreferrer"
                target="_blank"
                title={t("Follow us on Instagram")}
              >
                <i className="fab fa-instagram" />
                <p className="d-lg-none d-xl-none">Instagram</p>
              </NavLink>
            </NavItem>
            <NavItem className="p-0">
              <NavLink
                data-placement="bottom"
                href="#"
                rel="noopener noreferrer"
                title={t("Change Language")}
                onClick={ () => handleClose(currentLanguage === 'en'? 'pt_br' : 'en') }
              >
                <i className={classnames({
                          'fab': true,
                          'fa-pt-br': (getCookie('i18n_locale')? getCookie('i18n_locale') : currentLanguage) === 'pt_br',
                          'fa-en': (getCookie('i18n_locale')? getCookie('i18n_locale') : currentLanguage) === 'en',
                })} />
              </NavLink>
            </NavItem>     
                                
            <UncontrolledDropdown nav>
              <DropdownToggle
                caret
                color="default"
                data-toggle="dropdown"
                href="#pablo"
                nav
                onClick={(e) => e.preventDefault()}
              >
                <i className="fa fa-cogs d-lg-none d-xl-none" />
                <Trans>About us</Trans>
              </DropdownToggle>
              <DropdownMenu className="dropdown-with-icons">
                <DropdownItem tag={Link} to="/ministerios">
                  <i className="fa-solid fa-hand-holding-heart" />                  
                  <Trans>Ministries</Trans>
                </DropdownItem>
                <DropdownItem tag={Link} to="/missao-visao-valores">
                  <i className="fa fa-bullseye" />
                  <Trans>Mission, Vision and Values</Trans>
                </DropdownItem>
                <DropdownItem tag={Link} to="/nossos-pastores">
                  <i className="fa-solid fa-people-group" />
                  <Trans>Our shepherds</Trans>
                </DropdownItem>
                <DropdownItem tag={Link} to="/contato">
                  <i className="fa-solid fa-at" />
                  <Trans>Get in touch</Trans>
                </DropdownItem>                
              </DropdownMenu>
            </UncontrolledDropdown>
            <UncontrolledDropdown nav>
              <DropdownToggle
                caret
                color="default"
                data-toggle="dropdown"
                href="#pablo"
                nav
                onClick={(e) => e.preventDefault()}
              >
                <i className="fa fa-cogs d-lg-none d-xl-none" />
                <Trans>Start here</Trans>
              </DropdownToggle>
              <DropdownMenu className="dropdown-with-icons">
              <DropdownItem href="/confesse-jesus">
                  <i className="fa fa-pray" />
                  <Trans>Confess Jesus</Trans>
                </DropdownItem>                
                <DropdownItem href="/seja-membro">
                  <i className="fa fa-id-card" />
                  <Trans>Become a member</Trans>
                </DropdownItem>
                <DropdownItem tag={Link} to="/encontre-um-gc">
                  <i className="fa-solid fa-earth-americas"/>
                  <Trans>Find a GC</Trans>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>            
            <NavItem>
              <Button
                className="nav-link d-none d-lg-block"
                color="default"
                href="/seja-membro"
              >
                <i className="tim-icons icon-badge" /> <Trans>Become a member</Trans>
              </Button>
            </NavItem>
          </Nav>
        </Collapse>
      </Container>
    </Navbar>
  );
}
